/**
 * Resolve a file from `public/` against the running page, not the domain root.
 *
 * A built `dist/` can live at `/`, `/the-incomer-call/`, or `…/index.html`.
 * Root-absolute URLs (`/assets/…`) would 404 on a subdirectory host; `./` breaks
 * when the URL has no trailing slash. This always targets the app directory.
 */
export function publicPath(path: string): string {
  const rel = path.replace(/^\//, '');
  return `${appDirectory()}${rel}`;
}

function appDirectory(): string {
  const base = import.meta.env.BASE_URL || './';

  // An absolute base is authoritative, and unlike the page's own directory it
  // is still correct on a nested route. `/clip/<id>` and `/c/<code>` are PAGES
  // of this app, not directories of it — deriving the app root from the URL
  // there sends every public asset to `/clip/<id>/assets/…`.
  if (base !== './' && !base.startsWith('./')) {
    return base.endsWith('/') ? base : `${base}/`;
  }

  // Relative base: a subdirectory deploy, which has no nested routes to worry
  // about. Resolve against the page.
  if (typeof window === 'undefined') return './';

  let dir = window.location.pathname;
  if (dir.endsWith('.html')) {
    dir = dir.slice(0, dir.lastIndexOf('/') + 1);
  } else if (!dir.endsWith('/')) {
    dir = `${dir}/`;
  }
  return dir;
}
